import { Autocomplete, Box, Grid, TextField, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { selectCity } from "store/global/fields/selector";
import { actions } from "store/global/fields/slice";
import { useStyles } from "../styles";
interface TProps {
  value: number;
  xs?: number;
  changeValue: (value: number, name?: string) => void;
  disabled?: boolean;
  error?: string;
  isRequired?: boolean;
}
const CityField = (props: TProps) => {
  const dispatch = useDispatch();
  const styles = useStyles();
  const [value, setValue] = useState<any>({ id: 0, name: "", nameHw: "" });

  const List = useSelector(selectCity);
  const { t, i18n } = useTranslation();
  const isHebrewLanguage = i18n.language?.toLowerCase().startsWith("he");

  const getCityLabel = (option: any) => {
    if (!option) return "";
    const preferredLabel = isHebrewLanguage ? option.nameHw : option.name;
    const fallbackLabel = isHebrewLanguage ? option.name : option.nameHw;

    return preferredLabel || fallbackLabel || "";
  };

  useEffect(() => {
    dispatch(actions.getCityList());
    return () => {};
  }, [dispatch]);

  const handleChange = (event, newValue: any) => {
    if (newValue) {
      props.changeValue(newValue.id, getCityLabel(newValue));
    } else {
      props.changeValue(0, "");
    }
  };
  useEffect(() => {
    setValue(List.items.filter((x) => x.id === props.value)[0]);

    return () => {};
  }, [props.value, List]);

  return (
    <Grid item xs={props.xs ? props.xs : 2}>
      <label className={styles.label}>
        {t("ORGANIZATIONS.CITY")}
        {props.isRequired && <span style={{ color: "red" }}> *</span>}
      </label>
      <Autocomplete
        disabled={props.disabled}
        fullWidth
        id="cities"
        options={List.items}
        autoHighlight
        className={styles.textEnabled}
        onChange={(event: any, newValue: any) => handleChange(event, newValue)}
        value={value}
        ListboxProps={{
          style: {
            direction: isHebrewLanguage ? "rtl" : "ltr",
          },
        }}
        isOptionEqualToValue={(option, value) => option?.id === value?.id}
        getOptionLabel={(option) => getCityLabel(option)}
        renderOption={(props, option) => (
          <Box
            component="li"
            sx={{
              width: "100%",
              textAlign: isHebrewLanguage ? "right" : "left",
              "& > img": { mr: 2, flexShrink: 0 },
            }}
            {...props}
          >
            {getCityLabel(option)}
          </Box>
        )}
        renderInput={(params) => (
          <TextField
            {...params}
            label=""
            error={Boolean(props?.error)}
            inputProps={{
              ...params.inputProps,
            }}
            autoComplete="off"
          />
        )}
      />
      {props?.error && (
        <Box
          sx={{
            backgroundColor: "#fff",
            direction: i18n.dir(),
          }}
        >
          <Typography
            sx={{
              color: "#d32f2f",
              fontSize: "0.75rem",
            }}
            component="small"
          >
            {props?.error}
          </Typography>
        </Box>
      )}
    </Grid>
  );
};
export default CityField;
